module.exports = __webpack_public_path__ + "static/img/big2.967f97a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big2.png
// module id = o6Yw
// module chunks = 1